import { HttpResponse } from '@angular/common/http';

export enum MethodType {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export enum CacheTime {
  DEFAULT = 60 * 60 * 1000, // 1 hour
  LONG = 6 * 60 * 60 * 1000, // 6 hours
  SHORT = 10 * 60 * 1000, // 10 minutes
  VERY_LONG = 31 * 24 * 60 * 60 * 1000, // 31 days
}

export interface EndpointToCache {
  url: string;
  method: Extract<MethodType, MethodType.GET | MethodType.POST>;
}

export interface EndpointToClean {
  url: string;
  method: MethodType;
}

export interface CacheScenario {
  endpoint: EndpointToCache;
  cleaningEndpoints: EndpointToClean[];
  cacheTime: CacheTime|number;
  description?: string; // information for other developers if needed
}

export interface CachedValue {
  response: HttpResponse<unknown>;
  expiredAt: number;
  storedBody: unknown;
}

export const ANYTHING = ':anything' as const;
